module.exports = __webpack_public_path__ + "img/monkey_king_bar.99fdca1b.png";